// router.config.js
export const constantRouterMap = [
  {
    path: '/serve-download',
    name: 'DirectAccess',
    component: () => import('@/views/Serve/DownLoad')
  },
  {
    path: '*',
    redirect: '/serve-download'
  }
]
